import { defineField, defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "videoWithPosterImage",
  title: "Video",
  type: "object",
  preview: {
    select: {
      title: "caption",
      media: "posterImage"
    },
    prepare({ title, media }) {
      return {
        title: multilingualStringPreview(title),
        media
      };
    }
  },
  fields: [
    {
      name: "source",
      title: "Video Source",
      type: "string",
      initialValue: "widen",
      options: {
        list: ["widen", "youtube"],
        layout: "dropdown"
      },
      description: "If not specified, Widen is used by default"
    },
    {
      name: "file",
      title: "Video File",
      type: "widen.video",
      hidden: ({ parent }) => parent?.source === "youtube"
    },
    {
      name: "youtubeVideoId",
      title: "YouTube Video ID",
      type: "string",
      hidden: ({ parent }) => parent?.source !== "youtube",
      description: "Enter the YouTube video ID (the part after ?v= in the URL)"
    },
    {
      name: "trackingTitle",
      title: "Tracking Title",
      description: "(in English, for tracking only)",
      type: "string"
    },
    {
      name: "posterImage",
      title: "Poster Image",
      type: "image",
      options: {
        hotspot: true
      }
    },
    defineField({
      name: "caption",
      title: "Caption",
      type: "multilingualArrayString",
      options: {
        collapsible: true,
        collapsed: true
      }
    })
  ]
});
